import { render, staticRenderFns } from "./Gallery.vue?vue&type=template&id=a1359960&scoped=true&lang=pug"
import script from "./Gallery.vue?vue&type=script&lang=js"
export * from "./Gallery.vue?vue&type=script&lang=js"
import style0 from "./Gallery.styl?vue&type=style&index=0&id=a1359960&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1359960",
  null
  
)

export default component.exports